// Full-screen product image viewer
function createFullscreenViewer(image) {
  const overlay = document.createElement('div');
  overlay.className = 'product-image-fullscreen';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');

  const imageWrapper = document.createElement('div');
  imageWrapper.className = 'product-image-fullscreen__wrapper';

  const fullImage = document.createElement('img');
  fullImage.src = image.currentSrc || image.src;
  fullImage.alt = image.alt || '';

  const closeButton = document.createElement('button');
  closeButton.className = 'product-image-fullscreen__close';
  closeButton.type = 'button';
  closeButton.setAttribute('aria-label', 'Close image');
  closeButton.innerHTML = '&times;';

  imageWrapper.appendChild(fullImage);
  overlay.appendChild(closeButton);
  overlay.appendChild(imageWrapper);

  document.body.appendChild(overlay);

  // Prevent page scrolling while viewer is open
  document.body.classList.add('product-image-fullscreen-open');

  // Close viewer
  const closeViewer = () => {
    overlay.remove();
    document.body.classList.remove('product-image-fullscreen-open');
    document.removeEventListener('keydown', handleKeydown);
  };

  // Close button
  closeButton.addEventListener('click', (event) => {
    event.stopPropagation();
    closeViewer();
  });

  // Close when clicking outside the image
  overlay.addEventListener('click', (event) => {
    if (
      event.target === overlay ||
      event.target === imageWrapper
    ) {
      closeViewer();
    }
  });

  // ESC key
  const handleKeydown = (event) => {
    if (event.key === 'Escape') {
      closeViewer();
    }
  };

  document.addEventListener('keydown', handleKeydown);

  // Prevent image click from closing the viewer
  fullImage.addEventListener('click', (event) => {
    event.stopPropagation();
  });

  return overlay;
}


// Enable full-screen image on click
function enableFullscreenImageViewer() {
  const images = document.querySelectorAll('.image-magnify-hover');

  images.forEach((image) => {
    image.style.cursor = 'zoom-in';

    image.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      createFullscreenViewer(image);
    });
  });
}


enableFullscreenImageViewer();
